<template>
  <v-app>
    <div class="animated fadeIn">

      <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

      <div>
         <v-row>
            <v-col>
               <ddoSelectSwitchCustomer ref="mySelect"
                  @switchCustomer="refresh_page"
               >
               </ddoSelectSwitchCustomer>
            </v-col>
         </v-row>
      </div>

      <ddoClientList ref="myCustomers" :loading="loading" :level="levels[0]" 
          :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
          :customSlotNames="levels[0].customSlotNames"
          @loading="refresh_loading"
          @row="refresh_row"
          @childKey="refresh_childKey"
          @errors="refresh_errors"
          >

          <template v-slot:dialogform="{ row, level }">
            <CardUpdatableCustomerreseller ref="myCardCustomerreseller" :row="levels[0].row" :depth="levels[0].level" :level="levels[0]"
               @errors="refresh_errors"
               @change_dialogValues="change_dialogValues"
            />
          </template>

          <template v-if="session_row && !session_row.cut_is_admin && !session_row.cut_is_reseller" v-slot:header="{ row, level }">
               <!-- Must return something to override default slot content -->
               <span></span>
          </template>

          <template slot="searchengine" slot-scope="props">
               <v-card outlined max-width="400">
                  <h4>{{ $t('subtitles.filters') }} :</h4>
                  <v-col>
                     <v-text-field
                        v-model="levels[0].searchValues.cus_name"
                        :label="$t('texts._name')"
                        :hint="$t('hints._name')"
                        @change="filter_rows(0)"
                     ></v-text-field>
                     <b-radio-group id="cus_active" v-model="levels[0].searchValues.cus_active" label="Actif/Non Actif" @change="filter_rows(0)">
                        <b-radio value="">Tous</b-radio>
                        <b-radio value="true">Actif</b-radio>
                        <b-radio value="false">Non Actif</b-radio>
                     </b-radio-group>
                  </v-col>
               </v-card>
          </template>

         <template slot="cus_active" slot-scope="props">
            <b-checkbox disabled v-model="props.row.cus_active">Actif</b-checkbox>
            <b-checkbox disabled :checked="_checked_if_notnull(props.row.cus_bm_id)">ZOHO</b-checkbox>
         </template>

          <template slot="plf_list_names" slot-scope="props">
            <ul>
              <!--<li v-for="(step, index) in splitString(props.row.plf_list_names)">{{ step }}{{ additional_informations(props.row,index) }}</li>-->
              <li v-for="(step, index) in splitString(props.row.plf_list_names)" v-html="step+additional_informations(props.row,index)"></li>
            </ul>
          </template>

          <template v-slot:child_row="{ props }">
            <ddoClientList ref="myCustomerPlatforms" loading="loading" :level="levels[1]" :childKey="levels[1].childKey"
              :columns="levels[1].columns" :options="levels[1].options" :callbacks="levels[1].callbacks"
              :customSlotNames="levels[1].customSlotNames"
              @childKey="refresh_childKey"
              @row="refresh_row"
            >

            <template slot="header" slot-scope="props">
               <v-row>
                  <v-col sm="6">
                     <v-btn @click="load_for_create_by_PLF()" class="primary" rounded :disabled="buttonAttachPLF" small>{{ $t('buttons.attach_this_platform') }} :</v-btn>
                     <ddoSelectPlatform :callbacks="PLFcallbacks" ref="mySelectPLF" :options="PLFoptions"/>
                  </v-col>
                  <v-col sm="6">
                     <v-btn @click="load_for_create_by_SER()" class="primary" rounded :disabled="buttonAttachSER" small>{{ $t('buttons.attach_this_service') }} :</v-btn>
                     <ddoSelectService :callbacks="SERcallbacks" ref="mySelectSER" :options="SERoptions"/>
                  </v-col>
               </v-row>
            </template>

              <template v-slot:superheader="slotProps">
                <h3>{{ $api._format($t('subtitles.xxx_platforms'),slotProps.parentToggledRow['cus_name']) }}</h3>
              </template>

               <template slot="xxx_plf_name" slot-scope="props">
                  <div v-if="props.row.xxx_dyn_connector_name">{{ props.row.xxx_dyn_connector_name }}</div>
                  <div v-else>{{ props.row.plf_name }}</div>
               </template>

               <template slot="_data" slot-scope="props">

                  <div v-if="props.row.plf_auth_default">
                     <div>
                        {{ $t('subtitles.ldc_section_ou') }} : <strong>{{ props.row.xxx_ad_org_unit }}</strong>
                     </div>
                  </div>

                  <div v-if="props.row.plf_exchangelike">
                     <div>
                        {{ $t('subtitles.ldc_section_ou') }} : <strong>{{ props.row.xxx_ad_org_unit }}</strong>
                     </div>
                     <div>
                        {{ $t('texts._xxx_databases') }} : <strong>{{ props.row.xxx_databases }}</strong>
                     </div>
                     <div>
                        {{ $t('texts._xxx_servers') }} : <strong>{{ props.row.xxx_servers }}</strong>
                     </div>
                     <div>
                        {{ $t('texts._xxx_maxdbsize') }} : <strong>{{ props.row.xxx_maxdbsize }} {{ $t('utils.GB') }}</strong>
                     </div>
                  </div>

                  <div v-if="props.row.plf_smtplike">

                     <div v-if="props.row.xxx_maxusers>1">
                        {{ $t('texts.sasl_usernames') }} :
                        <strong>
                           <ul>
                              <li v-for="step in splitString(props.row.xxx_sasl_usernames)">{{ step }}</li>
                           </ul>
                        </strong>
                     </div>
                     <div v-else>
                        {{ $t('texts.sasl_username') }} : <strong>{{ props.row.xxx_sasl_usernames }}</strong>
                     </div>

                     <div v-if="props.row.xxx_active==true">
                        {{ $t('texts._status') }} : <strong>{{ $t('texts._activated') }}</strong>
                     </div>
                     <div v-else>
                        {{ $t('texts._status') }} : <strong>{{ $t('texts._deactivated') }}</strong>
                     </div>

                     <div v-if="props.row.xxx_suspended_since!=null">
                        {{ $t('texts._suspended') }} : <strong><mark>{{ $api._d(props.row.xxx_suspended_since,'long') }}</mark></strong>
                     </div>

                     <div v-if="props.row.xxx_expiration_date!=null">
                        {{ $t('texts._expires_on') }} : <strong><mark>{{ $api._d(props.row.xxx_expiration_date,'long') }}</mark></strong>
                     </div>

                     <p>
                        <div v-if="props.row.xxx_max_emails_per_month!=null">
                           {{ $t('texts.xxx_max_emails_per_month') }} : <strong>{{ props.row.xxx_max_emails_per_month }}</strong><br/>
                        </div>
                        <div v-if="props.row.xxx_max_gigabytes_per_month!=null">
                           {{ $t('texts.xxx_max_gigabytes_per_month') }} :  <strong>{{ props.row.xxx_max_gigabytes_per_month }}</strong><br/>
                        </div>
                        <div v-if="props.row.xxx_inform_to_emails!=null">
                           <br/>{{ $t('texts.xxx_inform_to_emails') }} :
                           <strong>{{ props.row.xxx_inform_to_emails }}</strong>
                        </div>
                        <div v-if="props.row.xxx_inform_cc_emails!=null">
                           {{ $t('texts.xxx_inform_cc_emails') }} :
                           <strong>{{ props.row.xxx_inform_cc_emails }}</strong>
                        </div>
                     </p>
                  </div>

                  <div v-if="props.row.plf_internalcode=='SMS'">
                     <div v-if="props.row.xxx_counter1_current!=null">
                        {{ $t('texts.xxx_sms_used') }} : <strong>{{ $api._format('%d',parseInt(props.row.xxx_counter1_current)) }}</strong> / {{ $api._format('%d',parseInt(props.row.xxx_counter1_max)) }}<br/>
                     </div>
                     <div v-if="props.row.xxx_active==true">
                        {{ $t('texts._status') }} : <strong>{{ $t('texts._activated') }}</strong>
                     </div>
                     <div v-else>
                        {{ $t('texts._status') }} : <strong>{{ $t('texts._deactivated') }}</strong>
                     </div>

                     <div v-if="props.row.xxx_inform_to_emails!=null">
                        <br/>{{ $t('texts.xxx_inform_to_emails') }} :
                        <strong>{{ props.row.xxx_inform_to_emails }}</strong>
                     </div>
                     <div v-if="props.row.xxx_inform_cc_emails!=null">
                        {{ $t('texts.xxx_inform_cc_emails') }} :
                        <strong>{{ props.row.xxx_inform_cc_emails }}</strong>
                     </div>
                     </p>
                  </div>

                  <div v-if="props.row.plf_internalcode=='BAREOS'">
                     <div v-if="props.row.xxx_maxusers>1">
                        {{ $t('texts.sasl_usernames_bareos') }} :
                        <strong>
                           <ul>
                              <li v-for="step in splitString(props.row.xxx_sasl_usernames)">{{ step }}</li>
                           </ul>
                        </strong>
                     </div>
                     <div v-else>
                        {{ $t('texts.sasl_username_bareos') }} : <strong>{{ props.row.xxx_sasl_usernames }}</strong>
                     </div>
                     <div v-if="props.row.xxx_inform_to_emails!=null">
                        {{ $t('texts.xxx_inform_to_emails') }} :
                        <strong>{{ props.row.xxx_inform_to_emails }}</strong>
                     </div>
                     <div v-if="props.row.xxx_inform_cc_emails!=null">
                        {{ $t('texts.xxx_inform_cc_emails') }} :
                        <strong>{{ props.row.xxx_inform_cc_emails }}</strong>
                     </div>
                     </p>
                  </div>

                  <div v-if="props.row.plf_internalcode=='CERTS'">
                     <div v-if="customer_has_certificates">
                        {{ $t('texts.certificates_list') }} :
                        <strong>
                           <ul>
                              <li v-for="certificate in certificates">{{ certificate.cer_cn }}</li>
                           </ul>
                        </strong>
                     </div>
                     <div v-if="props.row.xxx_inform_to_emails!=null">
                        {{ $t('texts.xxx_inform_to_emails') }} :
                        <strong>{{ props.row.xxx_inform_to_emails }}</strong>
                     </div>
                     <div v-if="props.row.xxx_inform_cc_emails!=null">
                        {{ $t('texts.xxx_inform_cc_emails') }} :
                        <strong>{{ props.row.xxx_inform_cc_emails }}</strong>
                     </div>
                     </p>
                  </div>

               </template>

               <template v-slot:dialogform="{ row, level }">
                  <CardUpdatableCUSPLFSLA v-if="levels[1].dialogValues.dialogShow.sla" :row="levels[1].row" :depth="levels[1].level" :level="levels[1]"
                     @errors="refresh_errors"
                  />
                  <CardUpdatableCUSPLFSMTPPRO v-if="levels[1].dialogValues.dialogShow.smtppro" :row="levels[1].row" :depth="levels[1].level" :level="levels[1]"
                     @errors="refresh_errors"
                  />
                  <CardUpdatableCUSPLFSMSPRO v-if="levels[1].dialogValues.dialogShow.smspro" :row="levels[1].row" :depth="levels[1].level" :level="levels[1]"
                     @errors="refresh_errors"
                  />
                  <CardUpdatableCUSPLFEXCHANGE v-if="levels[1].dialogValues.dialogShow.exchange" :row="levels[1].row" :depth="levels[1].level" :level="levels[1]"
                     @errors="refresh_errors"
                  />
                  <CardUpdatableCUSPLFLDAP  v-if="levels[1].dialogValues.dialogShow.ldap" :row="levels[1].row" :depth="levels[1].level" :level="levels[1]"
                     @errors="refresh_errors"
                  />
                  <CardUpdatableCUSPLFBAREOS v-if="levels[1].dialogValues.dialogShow.bareos" :row="levels[1].row" :depth="levels[1].level" :level="levels[1]"
                     @errors="refresh_errors"
                  />
                  <CardUpdatableCUSPLFCERTIFICATES v-if="levels[1].dialogValues.dialogShow.certificates" :row="levels[1].row" :depth="levels[1].level" :level="levels[1]"
                     @errors="refresh_errors"
                  />
               </template>

            </ddoClientList>
          </template>

        <template v-slot:superheader="{ errors }">
          <h1>{{ $t('titles.cus') }}</h1>
        </template>

      </ddoClientList>

    </div>
  </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoSelectSwitchCustomer from '@/components/ddoSelectSwitchCustomer.vue'
import BasicList from '@/views/BasicList.vue';
import { Event } from '@/components/ddoClientList.vue';

import CardUpdatableCustomerreseller from '@/components/partials/CardUpdatableCustomerreseller.vue';
import CardUpdatableCUSPLFSLA from '@/components/partials/CardUpdatableCUSPLFSLA.vue';
import CardUpdatableCUSPLFSMTPPRO from '@/components/partials/CardUpdatableCUSPLFSMTPPRO.vue';
import CardUpdatableCUSPLFSMSPRO from '@/components/partials/CardUpdatableCUSPLFSMSPRO.vue';
import CardUpdatableCUSPLFEXCHANGE from '@/components/partials/CardUpdatableCUSPLFEXCHANGE.vue';
import CardUpdatableCUSPLFLDAP from '@/components/partials/CardUpdatableCUSPLFLDAP.vue';
import CardUpdatableCUSPLFBAREOS from '@/components/partials/CardUpdatableCUSPLFBAREOS.vue';
import CardUpdatableCUSPLFCERTIFICATES from '@/components/partials/CardUpdatableCUSPLFCERTIFICATES.vue';
import ddoClientList from '@/components/ddoClientList.vue';
import ddoSelectPlatform from '@/components/ddoSelectPlatform.vue';
import ddoSelectService from '@/components/ddoSelectService.vue';


Vue.use(ddoClientList);

let initial_row = {}

export default {
  // name: 'customerreseller',
   name: 'customerresellers',
   mixins: [BasicList],
   components: {
      ddoAlert,
      ddoSelectSwitchCustomer,
      CardUpdatableCustomerreseller,
      CardUpdatableCUSPLFSLA,
      CardUpdatableCUSPLFSMTPPRO,
      CardUpdatableCUSPLFSMSPRO,
      CardUpdatableCUSPLFEXCHANGE,
      CardUpdatableCUSPLFLDAP,
      CardUpdatableCUSPLFBAREOS,
      CardUpdatableCUSPLFCERTIFICATES,
      ddoClientList,
      ddoSelectPlatform,
      ddoSelectService
   },

  data: () => {
    return {
      _this: null,
      loading: false,
      session_row: null,

      cut_code_default: 'NORM',
      cut_code_fieldname: 'cut_code',

      certificates: [],

      buttonAttachPLF: true,
      selectedPLF: {},
      PLFcallbacks: {},
      PLFoptions: {
         initial: null,
         required: true,
         disabled: false,
         multiple: false,
         clearable: false,
         item_text: "plf_name",
         item_value: "plf_pk",
         item_disabled: "",
         hide_selected: true,
         label: i18n.t('texts.platform'),
      },

      buttonAttachSER: true,
      selectedSER: {},
      SERcallbacks: {},
      SERoptions: {
         initial: null,
         required: true,
         disabled: false,
         multiple: false,
         clearable: false,
         item_text: "ser_name",
         item_value: "ser_pk",
         item_disabled: "",
         hide_selected: true,
         label: i18n.t('texts.service'),
      },

      /* 
       * LEVEL 1 : all for ddoClientList : columns, options, callbacks
       */
      levels: [

      /* 
       * In 'row' object, we need to declare 'cus_name' and 'cus_code', to be reactive.
       */
      {
         api_code: 'customerreseller',
         api_prefix: 'cus',
         row: { cus_name: null, cus_code: null },
         session_row: {},
         level: 0,
         errors: [],
         infos: [],
         columns: [ '_actions', 'cus_active', 'cus_code', 'cus_name', 'plf_list_names', '_update'],
         customSlotNames: ['cus_active','plf_list_names'],
         searchValues: {
            cus_name: null,
            cus_active: null,
         },
         options: {
            showChildRowToggler: false,
            withChild: true,
            hiddenColumns: [],
            headings: {
               _pk: i18n.t('headers.actions'),
               _child: i18n.t('headers._details'),
               cus_active: i18n.t('texts._active'),
               cus_pk: '#',
               net_ipv4: i18n.t('headers.flags'),
               cus_code: i18n.t('headers.code'),
               cus_name: i18n.t('headers.name'),
               plf_list_names: i18n.t('headers.platforms'),
               _update: i18n.t('headers.updated_on')
            },
            texts: {
            },
            uniqueKey: 'cus_pk',
            sortable: ['cus_code','_update'],
            filterable: false,
            sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
            columnsDropdown: false,
            columnsDisplay: {
               cus_code: 'not_mobile',
               _update: 'not_mobile',
            },
            pagination: {
               chunk: 5,
               edge: false,
               nav: 'scroll'
            },
            perPage: 100,
            perPageValues: [100,200,400],
            customFilters: [{
               name: 'search',
               callback: function (row, query) {
                  let $ret = true;
                  if ( $ret && query.cus_name!=null && query.cus_name!='' ) {
                     if ( row.cus_name && row.cus_name.indexOf(query.cus_name)<0 && row.cus_code && row.cus_code.indexOf(query.cus_name)<0 ) { $ret = false; }
                  }
                  let $ret0 = $ret;
                  if ( $ret && query.cus_active!=null && query.cus_active!='' ) {
                    if ( query.cus_active=="true" && row.cus_active==false ) { $ret = false; }
                    if ( query.cus_active=="false" && row.cus_active==true ) { $ret = false; }
                  }
                  return $ret;
               }
            }],
         },
         callbacks: {
         },
         dialogOptions: {
            codeRules : [
               (v) => !!v || i18n.t('texts._required')
            ],
            emailRules : [
               (v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,24})+$/.test(v) || i18n.t('texts._email_format'),
            ],
         },
         dialogValues: {
            headers: {
               select: i18n.t('texts.cus_select_title'),
               create: i18n.t('texts.cus_create_title'),
               update: i18n.t('texts.cus_update_title'),
               delete: i18n.t('texts.cus_delete_title'),
            },
            texts: {
               create_item: i18n.t('texts.cus_create_item'),
            },
            dialogShow: false,
            form_disabled: false,
            form_close: true,
            form_create: false,
            form_update: false,
            form_delete: false,
            disable_create: true,
            disable_update: false,
            disable_delete: false,
            readonly: false,
            header_value_function: function(row) { return row['cus_code']; }
         },
      },

      {
         api_code: 'customerplatform',
         api_prefix: 'cus',
         row: { xxx_maxusers: 0, plf_pk: null, cus_pk: null },
         level: 1,
         errors: [],
         infos: [],
         columns: [ '_actions', 'xxx_plf_name', '_data', '_update'],
         customSlotNames: ['xxx_plf_name','_data'],
         searchValues: {
         },
         options: {
            showChildRowToggler: false,
            withChild: false,
            hiddenColumns: [],
            headings: {
               _pk: i18n.t('headers.actions'),
               _child: i18n.t('headers.cus'),
               _data: i18n.t('headers._data'),
               cus_pk: '#',
               net_ipv4: i18n.t('headers.flags'),
               cus_code: i18n.t('headers.code'),
               cus_name: i18n.t('headers.name'),
               xxx_plf_name: i18n.t('headers.plf_name'),
               _update: i18n.t('headers.updated_on')
            },
            texts: {
            },
            uniqueKey: 'cus_plf_pk',
            sortable: ['cus_code','_update'],
            filterable: false,
            sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
            columnsDropdown: false,
            columnsDisplay: { _update: 'not_mobile' },
            pagination: {
               chunk: 5,
               edge: false,
               nav: 'scroll'
            },
            columnsDisplay: {
               _update: 'desktop',
               cus_code: 'desktop',
               cus_pk: 'desktop',
            },
            customFilters: [{
               name: 'search',
               callback: function (row, query) {
                  let $ret = true;
                  return $ret;
               }
            }],
         },
         callbacks: {
         },
         dialogOptions: {
            codeRules : [
               (v) => !!v || i18n.t('texts._required')
            ]
         },
         dialogValues: {
            headers: {
               select: i18n.t('texts.cusplf_select_title'),
               create: i18n.t('texts.cusplf_create_title'),
               update: i18n.t('texts.cusplf_update_title'),
               delete: i18n.t('texts.cusplf_delete_title'),
            },
            texts: {
               create_item: i18n.t('texts.plf_create_item'),
            },
            dialogShow: {
               smtppro: false,
               smspro: false,
               exchange: false,
               ldap: false,
               bareos: false,
               certificates: false,
            },
            form_disabled: false,
            form_close: true,
            form_create: false,
            form_update: false,
            form_delete: false,
            create_btn_disabled: true,
            update_btn_disabled: false,
            delete_btn_disabled: false,
            readonly: false,
            header_value_function: function(row) { return row['plf_name']; }
         },
      },

      ],

      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
    }
  },

  created() {
    this._this = this;
    this.levels[0].callbacks.configure_form = this.configure_form;
    this.levels[0].callbacks.prepare_create = this.prepare_create_l1;
    this.levels[0].callbacks.prepare_update = this.prepare_update_l1;
    this.levels[0].callbacks.prepare_delete = this.prepare_delete_l1;
    this.levels[0].callbacks.update_row     = this.update_row_l1;    
    this.levels[0].callbacks.show_dialog    = this.show_dialog;
    this.levels[0].callbacks.refresh_errors = this.refresh_errors;

    this.levels[1].callbacks.refresh_rows   = this.refresh_rows_l2;
    this.levels[1].callbacks.create_row     = this.create_row_l2;    
    this.levels[1].callbacks.update_row     = this.update_row_l2;    
    this.levels[1].callbacks.delete_row     = this.delete_row_l2;    
    this.levels[1].callbacks.prepare_create = this.prepare_create_l2;    
    this.levels[1].callbacks.prepare_update = this.prepare_update_l2;    
    this.levels[1].callbacks.prepare_delete = this.prepare_delete_l2;    
    this.levels[1].callbacks.configure_form = this.configure_form;
    this.levels[1].callbacks.show_dialog    = this.show_dialog;
    this.levels[1].callbacks.hide_dialog    = this.hide_dialog;
    this.levels[1].callbacks.refresh_errors = this.refresh_errors;

    this.levels[1].callbacks.check_skip_confirm = this.check_skip_confirm;
  },

   async mounted() {
      await this.refresh_session();

      this.PLFcallbacks.refresh_rows = this.build_select_plf;
      this.PLFcallbacks.change       = this.change_plf;
      this.SERcallbacks.refresh_rows = this.build_select_ser;
      this.SERcallbacks.change       = this.change_ser;
   },

   computed: {    
      customer_has_certificates: async function() {
         await this.get_certificates();
         return this.certificates.length>0
      },
   },

   methods: {

      _checked_if_notnull(value) {
         return ( value!=null ? true : false );
      },

      refresh_loading(value) {
         this.loading = value;
      },
      refresh_errors(level,errors) {
         this.levels[level].errors = errors;
      },
      refresh_row(level,row) {
         this.levels[level].row = row;
      },

      additional_informations(row,index) {
         //console.log("additional_informations, index="+index+", row="+JSON.stringify(row))
         let ret = "";
         let plf_list_all = row.plf_list_all.split(',');
         let values = null;
         if ( plf_list_all[index]!=null ) {
            values = plf_list_all[index].split('|');
            if ( values.length>=5 ) {
               switch( values[1] ) {
                  case "BAREOS":
                  case "SMTP-PRO":
                     ret = values[3];
                     break;
                  case "EXCH2010":
                     ret = values[4];
                     break;
                  case "AUTHENTICATION":
                     ret = values[4];
                     break;
               }
            }
         }
         if ( ret!="" ) {
            ret = " (<strong>"+ret+"</strong>)";
         }
         return ret;
      },

      async build_select_plf(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'customer/'+this.levels[1].childKey+'/availableplatforms');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async change_plf(value,item=null) {
         if ( item!=null ) {
            this.buttonAttachPLF = false;
            this.selectedPLF = item;
         } else {
            this.selectedPLF = this.$api._get_by_pk(this.$refs.mySelectPLF.items,value);
            this.buttonAttachPLF = false;
         }
      },

      async refresh_select_plf(key=null) {
         await this.$refs.mySelectPLF.refresh_rows(key);
      },

      async get_certificates(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'customer/'+this.levels[1].childKey+'/certificates');
         this.loading = false;
         this.certificates = [];
         if ( api_response.error==0 ) {
            this.certificates = api_response.rows;
         }
         console.log('get_certificates, this.certificates='+JSON.stringify(this.certificates))
      },

      async build_select_ser(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'customer/'+this.levels[1].childKey+'/availableservices');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async change_ser(value,item=null) {
         if ( item!=null ) {
            this.buttonAttachSER = false;
            this.selectedSER = item;
         } else {
            this.selectedSER = this.$api._get_by_pk(this.$refs.mySelectSER.items,value);
            this.buttonAttachSER = false;
         }
      },

      async load_for_create_by_PLF() {
         this.buttonAttachPLF = true;
         if ( this.levels[1].toggledRow ) {
            this.levels[1].customer = { cus_code: this.levels[1].toggledRow.cus_code, cus_name: this.levels[1].toggledRow.cus_name }
         }
         this.levels[1].row.cus_pk = this.levels[1].childKey;
         this.levels[1].row.xxx_maxusers = 1;
         this.levels[1].row.xxx_max_emails_per_month = null;
         this.levels[1].row.xxx_max_gigabytes_per_month = null;
         this.levels[1].row.xxx_sasl_usernames = null;
         this.levels[1].row.array_usernames = []; // required
         this.levels[1].row = { ...this.levels[1].row, ...this.selectedPLF }
         await this.$refs.myCustomerPlatforms.load_for_create();
         this.buttonAttachPLF = false;
      },

      async load_for_create_by_SER() {
         this.buttonAttachSER = true;
         if ( this.levels[1].toggledRow ) {
            this.levels[1].customer = { cus_code: this.levels[1].toggledRow.cus_code, cus_name: this.levels[1].toggledRow.cus_name }
         }
         this.levels[1].row.cus_pk = this.levels[1].childKey;
         this.levels[1].row.xxx_maxusers = 0;
         this.levels[1].row.xxx_max_emails_per_month = null;
         this.levels[1].row.xxx_max_gigabytes_per_month = null;
         this.levels[1].row.xxx_sasl_usernames = null;
         this.levels[1].row.array_usernames = []; // required
         this.levels[1].row = { ...this.levels[1].row, ...this.selectedSER }
         await this.$refs.myCustomerPlatforms.load_for_create();
         this.buttonAttachSER = false;
      },

      splitString(items) {
         // steps is a comma-separated string. We need to transform it in an array
         if ( typeof items == "string" ) {
            return items.split(',');
         } else {
            return [];
         }
      },

      async refresh_rows_l2(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[0].api_code+'/'+key+'/platforms');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async search_default_cut_value() {
         var cut_pk = null;
         if ( this.session_row && this.session_row.cus_pk ) {
            this.loading = true;
            let { errorinfos, api_response } = await this.$api.getRows(this.$router,'customer/'+this.session_row.cus_pk+'/customertypes');
            if ( api_response.error==0 ) {
               cut_pk = this.$api._get_pk_by_value(api_response.rows,this.cut_code_default,this.cut_code_fieldname);
            }
            this.loading = false;
         }
         return cut_pk;
      },

      async prepare_create_l1(parentKey=null) {
         this.levels[0].errors = [];
         this.levels[0].infos = [];
         this.levels[0].row.cus_name = '';
         this.levels[0].row.cus_code = '';
         this.levels[0].row.cus_active = true;
         this.levels[0].row.cus_blocked = false;
         this.levels[0].row.cus_siret = null;
         this.levels[0].row.cus_vatnumber = null;
         this.levels[0].dialogValues.disable_create = true;
         let cut_pk = await this.search_default_cut_value();
         this.levels[0].row.cut_pk = cut_pk;
         this.$refs.myCardCustomerreseller.CUSRESoptions.selected = null;
         this.$refs.myCardCustomerreseller.CUToptions.selected = cut_pk;
         if ( !this.levels[0].row.ctc_phones ) {
            this.levels[0].row.ctc_phones = { ctc_phone_fixed_phone: { nationalNumber: '' }, ctc_phone_cell_phone: { nationalNumber: '' } }
         }
      },

      async prepare_update_l1(parentKey,_pk,row,origin) {
         this.levels[0].errors = [];
         this.levels[0].infos = [];
         this.levels[0].row.cus_code = row.cus_code;
         this.$refs.myCardCustomerreseller.CUSRESoptions.selected = row.cus_pk_customer;
         console.log("prepare_update_l1, cus_pk_customer="+row.cus_pk_customer);
         this.$refs.myCardCustomerreseller.CUToptions.selected = row.cut_pk;
         this.$refs.myCardCustomerreseller.CTCoptions_general.selected = row.ctc_pk_general;
         this.$refs.myCardCustomerreseller.CTCoptions_invoicing.selected = row.ctc_pk_invoicing;
         this.$refs.myCardCustomerreseller.CTCoptions_shipping.selected = row.ctc_pk_shipping;
         this.$refs.myCardCustomerreseller.CTCoptions_general.triggers_refresh = true;
         this.$refs.myCardCustomerreseller.CTCoptions_invoicing.triggers_refresh = true;
         this.$refs.myCardCustomerreseller.CTCoptions_shipping.triggers_refresh = true;
         if ( row.cut_is_customer==true && row.cus_bm_id==null ) {
            var infos = { err_type: 'warning', err_value_text: this.$i18n.t('texts.cus_bm_id_warning') };
            this.levels[0].infos = [infos];
         }
      },

      async prepare_delete_l1(parentKey,_pk,row,origin) {
         this.levels[0].errors = [];
         this.levels[0].infos = [];
         this.$refs.myCardCustomerreseller.CUToptions.selected = row.cut_pk;
         this.$refs.myCardCustomerreseller.CTCoptions_general.selected = row.ctc_pk_general;
         this.$refs.myCardCustomerreseller.CTCoptions_invoicing.selected = row.ctc_pk_invoicing;
         this.$refs.myCardCustomerreseller.CTCoptions_shipping.selected = row.ctc_pk_shipping;
      },

      async prepare_create_l2(parentKey=null) {
         if ( this.levels[1].toggledRow ) {
            this.levels[1].customer = { cus_code: this.levels[1].toggledRow.cus_code, cus_name: this.levels[1].toggledRow.cus_name }
         }
         // We check on row.plf_smtplike, because '...dialogShow.smtppro' is not set yet.
         if ( this.levels[1].row.plf_smtplike && this.levels[1].row.plf_smtplike==true ) {
            // By default, we are now required to create one account per cus_plf row, for SMTP-PRO.
            this.levels[1].row.xxx_maxusers=1;
            this.levels[1].row.xxx_active=true;
         }
         this.levels[1].errors = [];
      },

      async prepare_update_l2(parentKey=null) {
         console.log('prepare_update_l2, row='+JSON.stringify(this.levels[1].row))
         this.levels[1].errors = [];
         if ( this.levels[1].row.xxx_sasl_usernames!=null ) {
            var usernames = this.levels[1].row.xxx_sasl_usernames.split(',');
            this.levels[1].row.array_usernames = usernames;
         }
         console.log('prepare_update_l2, array_usernames='+JSON.stringify(this.levels[1].row.array_usernames))
         
         this.levels[1].row.xxx_counter1_current = parseInt(this.levels[1].row.xxx_counter1_current);
         this.levels[1].row.xxx_counter1_max     = parseInt(this.levels[1].row.xxx_counter1_max);

         if ( this.levels[1].toggledRow ) {
            this.levels[1].customer = { cus_code: this.levels[1].toggledRow.cus_code, cus_name: this.levels[1].toggledRow.cus_name }
         }
      },

      async prepare_delete_l2(parentKey=null) {
         this.levels[1].errors = [];
         if ( this.levels[1].row.xxx_sasl_usernames!=null ) {
            var usernames = this.levels[1].row.xxx_sasl_usernames.split(',');
            this.levels[1].row.array_usernames = usernames;
         }
         if ( this.levels[1].toggledRow ) {
            this.levels[1].customer = { cus_code: this.levels[1].toggledRow.cus_code, cus_name: this.levels[1].toggledRow.cus_name }
         }
      },

      async ask_for_update_row_l2(router,api_code,_pk,row) {
         if ( this.levels[1].dialogValues.dialogShow.smtppro ) {
            this.levels[1].dialogValues.subdialogShow.smtppro = true;
            console.log('ask_for_update_row_l2, smtppro, _pk='+_pk);
         }
         if ( this.levels[1].dialogValues.dialogShow.ldap ) {
            this.levels[1].dialogValues.subdialogShow.ldap = true;
            console.log('ask_for_update_row_l2, ldap, _pk='+_pk);
         }
      },

      async create_row_l2(router,api_code,row) {
         console.log('create_row_l2, api_code='+api_code);
         console.log('create_row_l2, row='+JSON.stringify(row));
         console.log('create_row_l2, dialogShow='+JSON.stringify(this.levels[1].dialogValues.dialogShow));
         if ( this.levels[1].dialogValues.dialogShow.smtppro ) {
            console.log('create_row_l2, smtppro, row='+JSON.stringify(row));
            var { errorinfos, api_response } = await this.$api.createRow(router,api_code,row,'insert_smtppro');
            return { errorinfos, api_response }
         }
         if ( this.levels[1].dialogValues.dialogShow.smspro ) {
            console.log('create_row_l2, smspro, row='+JSON.stringify(row));
            var { errorinfos, api_response } = await this.$api.createRow(router,api_code,row,'insert_smspro');
            return { errorinfos, api_response }
         }
         if ( this.levels[1].dialogValues.dialogShow.ldap ) {
            console.log('create_row_l2, ldap, row='+JSON.stringify(row));
            var { errorinfos, api_response } = await this.$api.createRow(router,api_code,row,'insert_ldap');
            return { errorinfos, api_response }
         }
         if ( this.levels[1].dialogValues.dialogShow.bareos ) {
            console.log('create_row_l2, bareos, row='+JSON.stringify(row));
            var { errorinfos, api_response } = await this.$api.createRow(router,api_code,row,'insert_bareos');
            return { errorinfos, api_response }
         }
         if ( this.levels[1].dialogValues.dialogShow.certificates ) {
            console.log('create_row_l2, service, row='+JSON.stringify(row));
            var { errorinfos, api_response } = await this.$api.createRow(router,api_code,row,'insert_service');
            return { errorinfos, api_response }
         }
      },

      async update_row_l1(router,api_code,_pk,row) {
         var { errorinfos, api_response } = await this.$api.updateRow(router,api_code,_pk,row,'update_essentials');
         //console.log('update_row_l1, api_respinse='+JSON.stringify(api_response))
         return { errorinfos, api_response }
      },

      async update_row_l2(router,api_code,_pk,row) {
         if ( this.levels[1].dialogValues.dialogShow.smtppro ) {
            var { errorinfos, api_response } = await this.$api.updateRow(router,api_code,_pk,row,'update_smtppro');
            return { errorinfos, api_response }
         }
         if ( this.levels[1].dialogValues.dialogShow.smspro ) {
            var { errorinfos, api_response } = await this.$api.updateRow(router,api_code,_pk,row,'update_smspro');
            return { errorinfos, api_response }
         }
         /*
          * For DynLdap or Auth platforms, it's better to query against 'ldapconnector' keyword, instead of 'customerplatform'
          */
         if ( this.levels[1].dialogValues.dialogShow.ldap ) {
            var { errorinfos, api_response } = await this.$api.updateRow(router,'ldapconnector',_pk,row);
            return { errorinfos, api_response }
         }
         if ( this.levels[1].dialogValues.dialogShow.bareos ) {
            var { errorinfos, api_response } = await this.$api.updateRow(router,api_code,_pk,row,'update_bareos');
            return { errorinfos, api_response }
         }
         if ( this.levels[1].dialogValues.dialogShow.certificates ) {
            var { errorinfos, api_response } = await this.$api.updateRow(router,api_code,_pk,row,'udpate_service');
            return { errorinfos, api_response }
         }
      },

      async delete_row_l2(router,api_code,_pk,row) {
         if ( this.levels[1].dialogValues.dialogShow.smtppro ) {
            var { errorinfos, api_response } = await this.$api.deleteRow(router,api_code,_pk,'delete_smtppro');
            return { errorinfos, api_response }
         }
         if ( this.levels[1].dialogValues.dialogShow.bareos) {
            var { errorinfos, api_response } = await this.$api.deleteRow(router,api_code,_pk,'delete_bareos');
            return { errorinfos, api_response }
         }
         if ( this.levels[1].dialogValues.dialogShow.certificates) {
            var { errorinfos, api_response } = await this.$api.deleteRow(router,api_code,_pk,'delete_service');
            return { errorinfos, api_response }
         }
      },

      filter_rows(level) {
         Event.$emit('vue-tables.filter::search', this.levels[level].searchValues);
      },

      async refresh_session() {
         var { errorinfos, api_response } = await this.$api._get_session(this.$router);
         //console.log('refresh_session, session='+JSON.stringify(api_response.row))
         if ( api_response.error==0 && api_response.row ) {
            this.session_row = api_response.row;
            this.levels[0].session_row = api_response.row;
         }
      },

      recompute_values() {
         if ( this.session_row!=null ) {
            var readonly = this.session_row.cut_is_customer;
            this.levels[0].dialogValues.readonly = readonly;
            this.levels[1].dialogValues.readonly = readonly;
         }
      },

      async refresh_page(session_row) {
         this.session_row = session_row;
         this.levels[0].session_row = session_row;
         await this.$refs.myCustomers.refresh_rows();
      },

      show_dialog(level,show) {
         let _dV = this.levels[level].dialogValues;
         _dV.header_value = _dV.header_value_function(this.levels[level].row);
         console.log('show_dialog, level='+level+', row='+JSON.stringify(this.levels[level].row));
         if ( level==1 ) {
            _dV.dialogShow = { smtppro: false, smspro: false, exchange: false, ldap: false, bareos: false };
            if ( this.levels[level].row.plf_smtplike ) {
               _dV.dialogShow.smtppro = show;
            }
            if ( this.levels[level].row.plf_exchangelike ) {
               _dV.dialogShow.exchange = show;
            }
            if ( this.levels[level].row.plf_is_dynamic || this.levels[level].row.plf_is_auth ) {
               _dV.dialogShow.ldap = show;
            }
            if ( this.levels[level].row.plf_internalcode=='SMS' ) {
               _dV.dialogShow.smspro = show;
            }
            if ( this.levels[level].row.plf_internalcode=='BAREOS' ) {
               _dV.dialogShow.bareos = show;
            }
            if ( this.levels[level].row.ser_code=='CERTIFICATES' ) {
               _dV.dialogShow.certificates = show;
            }
         } else {
            _dV.dialogShow = show;
         }
         this.levels[level].dialogValues = _dV;
      },

      hide_dialog(level) {
         this.show_dialog(level,false);
      },

      check_skip_confirm(method,row) {
         var check = false;
         switch (method) {
            case 'create':
            case 'update':
               check = (row.xxx_changes_sasl_usernames==null);
               break;
            case 'delete':
               row.xxx_changes_sasl_usernames = [];
               if ( row.xxx_sasl_usernames!=null ) {
                  var list = row.xxx_sasl_usernames.split(',');
                  var deletelist = [];
                  for ( var i=0; i<list.length;i++ ) {
                     deletelist.push( {username: list[i]} );
                  }
                  row.xxx_changes_sasl_usernames = { delete: deletelist }
               }
               break;
         }
         return check;
      },

      change_dialogValues(level,property,value) {
         console.log('change_dialogValues, level='+level+', property='+property+', value='+value)
         this.levels[level].dialogValues[property] = value;
      },

   }
}
</script>